export default "__VITE_ASSET__B12WE0U___"